import React, { useEffect, useState, useCallback } from "react";
import { API_IP } from "../global_variables";
import { axiosReqConfig } from "../functions/axiosRequest";
import AddPatientModal from "./UserPatientScreen/AddPatientModal";
import "../styles.css";

const UserPatientListScreen = ({ renderPatientProfile }) => {
  const [patientsData, setPatientsData] = useState([]);
  const [isAddPatVisible, setIsAddPatVisible] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);

  const toggleAddPatient = () => {
    setIsAddPatVisible(!isAddPatVisible);
  };
  const toggleRefresh = () => {
    setIsRefresh(!isRefresh);
  };
  var count = 0;
  const profileImages = [
    "../images/avatar_placeholder_1.png",
    "../images/avatar_placeholder_2.png",
    "../images/avatar_placeholder_3.png",
    "../images/avatar_placeholder_4.png",
  ];

  // Function to pick a random image
  const getRandomImage = () => {
    let number = 0;
    if (count >= 3) {
      count = 0;
      number = count;
    } else {
      count = count + 1;
      number = count;
    }
    return number;
  };

  const getAllPatientsData = useCallback(async () => {
    const data = await axiosReqConfig(`${API_IP}/api/patients`, "get", []);
    setPatientsData(data.patients);
  }, [isRefresh]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getAllPatientsData();
    }
    return () => {
      isMounted = false;
    };
  }, [getAllPatientsData]);
  return (
    <>
      <div className="patient-profile-header">
        <div>
          <h2>Self/Family Members</h2>
          <p>List of all members that are associated with your account.</p>
        </div>
        {patientsData.length == 0 ? (
          <></>
        ) : (
          <button className="patient-add-button" onClick={toggleAddPatient}>
            <p>Add New Member</p>
          </button>
        )}
      </div>

      <div className="patient-profile-grid">
        {patientsData.map((profile, index) => {
          const img = getRandomImage();
          return (
            <div
              key={index}
              className="patient-profile-card"
              onClick={() => {
                renderPatientProfile(profile, img);
              }}
            >
              <img
                src={require(`../images/avatar_placeholder_${img}.png`)}
                alt={profile.name}
                className="patient-profile-img"
              />
              <h3>
                {profile.first_name} {profile.last_name}
              </h3>
              <p>
                {profile.city}, {profile.province}
              </p>
              <strong>{profile.birth_year}</strong>
            </div>
          );
        })}
        {patientsData.length == 0 ? (
          <div className="patient-empty-container">
            <p>You currently don not have any member profile</p>
            <button className="patient-add-button" onClick={toggleAddPatient}>
              <p>Add New Member</p>
            </button>
          </div>
        ) : (
          <></>
        )}
      </div>
      <AddPatientModal
        handleClose={toggleAddPatient}
        toggleRefresh={toggleRefresh}
        showModal={isAddPatVisible}
      />
    </>
  );
};

export default UserPatientListScreen;
